import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i602242273__Ebene_1",
  viewBox: "0 0 192 192"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("desc", null, "Information", -1)),
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i602242273__cls-1{fill:#2d2d2d}")
        ])),
        _: 1
      }))
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("path", {
      d: "M30.29 181c-.87 0-1.74-.28-2.45-.84-1.28-1-1.84-2.67-1.4-4.24l8.81-31.46c-13.51-15.05-20.93-34.35-20.93-54.62C14.33 44.71 51.04 8 96.16 8s81.83 36.71 81.83 81.84-36.71 81.84-81.83 81.84c-12.24 0-24-2.64-35-7.87l-28.87 16.66c-.62.36-1.31.54-2 .54ZM96.16 16c-40.71 0-73.83 33.12-73.83 73.84 0 18.97 7.2 37.01 20.28 50.8.97 1.02 1.33 2.48.95 3.83l-6.77 24.17 22.22-12.82c1.17-.68 2.6-.71 3.81-.1 10.42 5.28 21.64 7.96 33.34 7.96 40.71 0 73.83-33.12 73.83-73.84S136.87 16 96.16 16",
      class: "i602242273__cls-1"
    }, null, -1)),
    _cache[3] || (_cache[3] = _createElementVNode("path", {
      d: "M96 68c-8.82 0-16-7.18-16-16s7.18-16 16-16 16 7.18 16 16-7.18 16-16 16m0-24c-4.41 0-8 3.59-8 8s3.59 8 8 8 8-3.59 8-8-3.59-8-8-8M96 144c-8.82 0-16-7.18-16-16V92c0-8.82 7.18-16 16-16s16 7.18 16 16v36c0 8.82-7.18 16-16 16m0-60c-4.41 0-8 3.59-8 8v36c0 4.41 3.59 8 8 8s8-3.59 8-8V92c0-4.41-3.59-8-8-8",
      class: "i602242273__cls-1"
    }, null, -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "info"}) } }